import { IUserMilestone } from '../../IUserMilestone';

export const HAS_VISITED_CATEGORY_SEARCH_PAGES =
  'HAS_VISITED_CATEGORY_SEARCH_PAGES' as IUserMilestone.RetailerMilestone;
